import { graphql } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';
import invariant from 'invariant';
import * as React from 'react';

import PhoneCallModalContent from 'phoneCalls/components/PhoneCallModalContent';
import User from 'entities/User';
import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import Dialog from 'components/Dialog';
import TitleHeader from 'components/TitleHeader';
import LoadingModal from 'components/LoadingModal';
import IndividualChatStarter from 'components/IndividualChatStarter';
import UsersAddNumberToUserModal from 'users/components/UsersAddNumberToUserModal';
import LinkDeviceModal from 'user/components/LinkDeviceModal';

export type DenialReason =
  | void
  | 'blocked'
  | 'callee_is_remind_bot'
  | 'callee_has_multiple_devices'
  | 'no_callee_phone_on_file'
  | 'callee_not_in_office'
  | 'callee_under_13'
  | 'caller_has_multiple_devices'
  | 'caller_muted'
  | 'caller_under_13'
  | 'no_caller_phone_on_file'
  | 'feature_not_available'
  | 'two_way_messaging_disabled'
  | 'group_chat'
  | 'self_chat'
  | 'chad_chat';

export function isFixableDenialReason(denialReason: DenialReason) {
  return ['no_callee_phone_on_file', 'callee_not_in_office', 'no_caller_phone_on_file'].includes(
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'DenialReason' is not assignable ... Remove this comment to see the full error message
    denialReason
  );
}

type Props = {
  calleeUuid: string;
  onRequestHide: Function;
  callee:
    | {
        name: string;
        uuid: string;
        canPhoneDenialReason: DenialReason | undefined | null;
        id: number;
      }
    | undefined
    | null;
  loading: boolean;
  refetch: Function;
};

class PhoneCallModal extends React.Component<Props> {
  render() {
    const { callee, loading, onRequestHide, refetch } = this.props;
    if (loading || !callee) {
      return <LoadingModal />;
    } else if (callee.canPhoneDenialReason === 'no_caller_phone_on_file') {
      return (
        <LinkDeviceModal
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          onDone={refetch}
          onDialogDismiss={onRequestHide}
          title="Add your mobile number to Remind to start making calls"
          deviceType="phoneNumber"
        />
      );
    } else if (callee.canPhoneDenialReason === 'no_callee_phone_on_file') {
      return (
        <UsersAddNumberToUserModal
          // @ts-expect-error
          userId={callee.id}
          userUuid={callee.uuid}
          userName={callee.name}
          startCall={refetch}
          onCancel={onRequestHide}
          onRequestHide={() => {}}
          subtext={`To call ${callee.name}, add their mobile number to Remind first.`}
          submitLabel={`Call ${callee.name}`}
        />
      );
    } else if (callee.canPhoneDenialReason === 'callee_not_in_office') {
      return (
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        <Dialog size="xxsmall" onRequestHide={onRequestHide}>
          <BoxBody>
            <TitleHeader
              subtext={`It's currently outside of ${callee.name}'s office hours. Please send a message instead if you need immediate assistance.`}
              title="Office hours"
            />
            <IndividualChatStarter user={User.fromJSON(callee)}>
              <Button level="primary" color="mascot">
                Send a message
              </Button>
            </IndividualChatStarter>
          </BoxBody>
        </Dialog>
      );
    } else if (callee.canPhoneDenialReason) {
      // continue to start the call so the user gets feedback from the error response
      console.error(
        `PhoneCallModal call started with unfixable denial reason ${callee.canPhoneDenialReason}`
      );
    }
    return (
      <PhoneCallModalContent
        onRequestHide={onRequestHide}
        calleeName={callee.name}
        calleeUuid={callee.uuid}
      />
    );
  }
}

const withUser = graphql(
  gql`
    query PhoneCallModal($uuids: [String!]!) {
      me {
        uuid
        connectedUsers(uuids: $uuids) {
          uuid
          name
          id
          canPhoneDenialReason
        }
      }
    }
  `,
  {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'calleeUuid' does not exist on type '{}'.
    options: ({ calleeUuid }) => ({
      variables: { uuids: [calleeUuid] },
      fetchPolicy: 'network-only',
    }),
    props: ({ data }) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      if (data.me) {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        invariant(data.me.connectedUsers, 'User missing connected users in chat');
      }
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      const callee = data.me ? data.me.connectedUsers[0] : undefined;
      return {
        callee,
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        loading: data.loading,
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        refetch: data.refetch,
      };
    },
  }
);

export { PhoneCallModal };
export default compose(withUser)(PhoneCallModal);
